import React, { useState } from "react"
import { Form, message } from "antd"
import "../../styles/Pages/addmanual.css"
import { useNavigate, useParams } from "react-router-dom"
import { Product } from "../../Apis/productApis"
import ProductFormItem from "../../components/Products/ProductFormItem"
import { translations } from "../../utils/Translation/staticTranslation"

const ProductForm = () => {
  const { storeId } = useParams() // Get store id from URL parameter
  const [form] = Form.useForm()
  const [productForms, setProductForms] = useState([{ id: 1 }])
  const [loading, setLoading] = useState(false)
  const navigate = useNavigate()

  const lang = localStorage.getItem("language") || "ar"
  const addManualPage = translations[lang]?.productPage?.add_manual_page
  const common_btn = translations[lang]?.common_btn
  const product = translations[lang]?.productPage
  const addProductForm = async () => {
    try {
      await form.validateFields()
      setProductForms([...productForms, { id: productForms.length + 1 }])
    } catch (error) {
      message.error(addManualPage?.add_manual_validation)
    }
  }

  const onFinish = async (values) => {
    setLoading(true)
    try {
      const products = productForms.map((formItem, index) => ({
        product_name: values[`product_name_${formItem.id}`],
        price_amount: values[`price_amount_${formItem.id}`],
        price_unit: values[`price_unit_${formItem.id}`],
        image_url: values[`image_url_${formItem.id}`],
        product_url: values[`product_url_${formItem.id}`],
        category: values[`category_${formItem.id}`],
      }))

      const payload = {
        products,
        store: storeId,
      }

      const response = await Product.addProduct(payload)
      if (response.status) {
        form.resetFields()
        setProductForms([{ id: 1 }]) // Reset form state
        message.success(addManualPage?.product_added_successfully)
      }
    } catch (error) {
      message.error(
        lang === "en"
          ? error.response.data.error
          : error.response.data.errorArabic
      )
    } finally {
      setLoading(false)
    }
  }

  const handleCancel = () => {
    form.resetFields()
    setProductForms([{ id: 1 }]) // Reset to initial state
  }

  return (
    <div className="h-100">
      <div className="d-flex flex-column h-100">
        <div className="d-flex mb-22">
          <div>
            <img
              style={{ transform: lang === "ar" ? "rotateY(180deg)" : "none" }}
              src="/icons/backpagearrow.svg"
              alt=""
              className={`${lang === "ar" ? "ml-10" : "mr-10"} pointer`}
              onClick={() => navigate("/products")}
            />
          </div>
          <div>
            <h1 className="text-141414 text-20">{product?.add_manually} </h1>
            <p className="text-504943 text-13 mb-0">
              {product?.products}{" "}
              <span className="text-85849D">/ {product?.add_manually}</span>
            </p>
          </div>
        </div>
        <Form form={form} layout="vertical" onFinish={onFinish}>
          <div>
            {productForms.map((formItem) => (
              <ProductFormItem
                key={formItem.id}
                formItem={formItem}
                className="content-fit-container"
              />
            ))}

            {/* Button to add another product form */}
            <div
              className="content-fit-container mb-22"
              onClick={addProductForm}
              style={{ cursor: "pointer" }}
            >
              <div className="d-flex align-items-center">
                <div
                  className={`plus-icon d-flex ${
                    lang === "ar" ? "ml-10 " : "mr-10"
                  }`}
                >
                  <img src="/icons/plusicon.svg" alt="plus-icon" />
                </div>
                <p className="text-A1A1A1 font-400 text-14 mb-0">
                  {addManualPage?.add_another_product}
                </p>
              </div>
            </div>
          </div>

          <div className="d-flex justify-content-end">
            <button
              className={`cancel-btn ${lang === "ar" ? "ml-10 " : "mr-10"}`}
              type="button"
              onClick={handleCancel}
            >
              {common_btn?.cancel_btn}
            </button>
            <button
              disabled={loading}
              type="submit"
              className={`Add-btn bg-504943 ${loading && "not-allowed"}`}
            >
              {common_btn?.add_btn}
            </button>
          </div>
        </Form>
      </div>
    </div>
  )
}

export default ProductForm
